export const authors = {
  PublishWeaver: {
    name: 'PublishWeaver',
    role: 'Lock the truth. Express everywhere. Drift never.',
    bio: 'PublishWeaver writes about governed content, editorial systems, and product evolution.'
  },
  'Chad Crossman': {
    name: 'Chad Crossman',
    role: 'Strategic Technology Leader',
    bio: 'Writing on whatever takes my fancy.'
  }
} as const;
